module.exports = __webpack_public_path__ + "static/media/naysan.9f04dfd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/naysan.jpg
// module id = 140
// module chunks = 0